var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoccer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "currentcolor",
      color: "currentcolor",
      width: 18,
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.387 23.172c1.771 0.871 3.718 1.352 5.737 1.396l3.374-3.865c0.039-2.281-0.488-4.534-1.532-6.551l-6.673-1.554c-1.393 1.395-2.473 3.075-3.158 4.927l2.252 5.647zM9.035 24.272l-2.256 1.88c2.435 2.213 5.67 3.562 9.221 3.562 0.681 0 1.351-0.050 2.006-0.146l-2.891-3.858c-2.134-0.044-4.197-0.54-6.079-1.439zM2.312 16.863h3.852c0.77-1.962 1.951-3.737 3.458-5.209v-4.374c-1.269-0.312-2.575-0.44-3.881-0.381-2.15 2.421-3.455 5.609-3.455 9.101 0 0.29 0.009 0.577 0.027 0.863zM25.215 20.464c1.191-1.213 2.148-2.636 2.818-4.195l-1.821-6.213c-1.544-0.786-3.227-1.273-4.977-1.43l-3.096 5.316c0.927 1.901 1.437 3.983 1.497 6.102l5.579 0.42zM25.878 21.418v4.095c2.169-2.252 3.576-5.244 3.803-8.56l-0.65-0.114c-0.753 1.709-1.823 3.263-3.154 4.579zM26.665 7.377c-2.016-2.49-4.886-4.26-8.165-4.864-0.462 0.54-0.88 1.113-1.25 1.715l3.744 3.233c1.851 0.122 3.639 0.586 5.292 1.359l0.379-1.443zM16.113 3.901c0.319-0.544 0.672-1.067 1.059-1.566-0.386-0.033-0.777-0.049-1.171-0.049-3.498 0-6.69 1.31-9.113 3.466 1.095 0.039 2.183 0.199 3.245 0.479l5.98-2.329zM16 32c-8.837 0-16-7.163-16-16s7.163-16 16-16c8.837 0 16 7.163 16 16s-7.163 16-16 16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default __webpack_public_path__ + "static/media/soccer.e4fb593f84e5cc5cd7c1541cf82530cb.svg";
export { ForwardRef as ReactComponent };